import { useListProjectLocationsQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

const useListProjectLocations = (project_id: string, nameOnly?: boolean) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, isLoading } = useListProjectLocationsQuery({
    slug: accountSlug,
    filter: { project: project_id },
  });

  let locations: { label: string; value: string }[] = [];

  if (data?.data) {
    locations = data.data.map((location) => {
      const {
        name,
        street,
        street2,
        city,
        state,
        "postal-code": postalCode,
        country,
      } = location.attributes;

      const address = [
        street,
        street2,
        city,
        state,
        postalCode,
        (country || "").toUpperCase(),
      ]
        .filter((part) => !!part?.trim())
        .join(", ");

      return {
        value: String(location.id),
        label: nameOnly ? name : name + " - " + address,
      };
    });
  }
  return {
    locations,
    locationsLoading: isLoading,
  };
};

export default useListProjectLocations;
